field1 = document.getElementById('field1')
field2 = document.getElementById('field2')
genderField = document.getElementById('gender')
fieldResult = document.getElementById('fieldResult')
feedback = document.getElementById('feedback')
ageField = document.getElementById('age')

updateFeedback()
function updateFields () {
    var weight = field1.value
    var height = field2.value / 100
    var result = weight/(height*height)
    var gender = genderField.value
    var age = ageField.value
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        fieldResult.value = Math.round(result);
        updateFeedback(result, gender, age);
    }
}


function updateFeedback(bmi, gender, age) {
    
    var evaluation = 'NaN'
    var idealBMI = 'NaN'

    if (gender == 'Mann') {
        if (bmi <  18.5              ) {evaluation = 'Untergewicht'}
        if (bmi > 18.5 && bmi < 24.9) {evaluation = 'Normalgewicht'}
        if (bmi > 24.9 && bmi < 29.9) {evaluation = 'Übergewicht'}
        if (bmi > 29.9 && bmi < 34.9) {evaluation = 'starkem Übergewicht'}
        if (bmi > 34.9              ) {evaluation = 'Adipositas'}
    }

    if (gender == 'Frau') {
        if (bmi <  17.5              ) {evaluation = 'Untergewicht'}
        if (bmi > 17.5 && bmi < 24  ) {evaluation = 'Normalgewicht'}
        if (bmi > 24 && bmi < 29    ) {evaluation = 'Übergewicht'}
        if (bmi > 29 && bmi < 34    ) {evaluation = 'starkem Übergewicht'}
        if (bmi > 34                ) {evaluation = 'Adipositas'}
    }

    if (gender == 'Mann') {
        if (age <  24                ) {idealBMI = '19 - 24'}
        if (age >= 25 && age < 35    ) {idealBMI = '20 - 25'}
        if (age >= 35 && age < 45    ) {idealBMI = '21 - 26'}
        if (age >= 45 && age < 55    ) {idealBMI = '22 - 27'}
        if (age >= 55 && age < 65    ) {idealBMI = '23 - 28'}
        if (age >= 65 && age < 90    ) {idealBMI = '25 - 30'}
    }

    if (gender == 'Frau') {
        if (age <  24                ) {idealBMI = '19 - 24'}
        if (age >= 25 && age < 35    ) {idealBMI = '20 - 25'}
        if (age >= 35 && age < 45    ) {idealBMI = '21 - 26'}
        if (age >= 45 && age < 55    ) {idealBMI = '22 - 27'}
        if (age >= 55 && age < 65    ) {idealBMI = '23 - 28'}
        if (age >= 65 && age < 90    ) {idealBMI = '25 - 30'}
    }

    console.log(evaluation)
    console.log(idealBMI)

    if (String(evaluation) != 'NaN' && String(idealBMI) != 'NaN') {

        feedback.innerHTML = `<h2> Dein BMI: ${Math.round(bmi)} </h2>
        Für dein Alter und dein Geschlecht ergibt sich für dich ein BMI von ca. ${Math.round(bmi)}. Das entspricht ${evaluation}. In diesem Alter liegt der perfekte BMI bei ${idealBMI}.`

    }
    
}